export default url => (url.includes('?') ? '&' : '?');
